/**
 * Formats an ISO date string for locale display, or an em dash when missing.
 */
export function formatDisplayDate(value?: string | null): string {
  if (!value) return '—';
  return new Date(value).toLocaleDateString();
}
